/**
 * 360-AUDIT wave 2 (B) — honest scope labels. On a multi-property account,
 * some surfaces are per-property (Service, Equipment, Signals) and some are
 * whole-account by design (History, Invoices, the balance strip, Membership —
 * money and history follow the CUSTOMER, not the address). That's the right
 * behavior, but it was unlabeled: a dispatcher on "123 Main St" could read the
 * History tab as that property's history. This chip says what's actually shown.
 */
import { Building2 } from "lucide-react";

export function AllPropertiesChip({ show }: { show: boolean }) {
  if (!show) return null;
  return (
    <span
      title="Shows records from EVERY property on this account — not just the property selected above"
      className="inline-flex shrink-0 cursor-help items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-500"
    >
      <Building2 className="h-3 w-3" /> All properties
    </span>
  );
}
